export default __webpack_public_path__ + "static/media/callblocker_mobile.ff0b55dd.png";